setPriceCookie();

jQuery(document).ready(function($) {
    jQuery(document).on('click', '#PriceSwatch', function(e) {
      e.preventDefault();
      setPriceCookie("Clicked");
    });
    setPriceCookie();
});

function setPriceCookie(btnval) {
    var btnval = btnval;
    var priceVal = readCookie("PriceSwatch");
    var buttonVal = readCookie("PriceBtnLabel");
  
    if(priceVal != "" && priceVal == "HIDE"){
      var buttonVal = readCookie("PriceBtnLabel");
      jQuery("#PriceSwatch").html(buttonVal);
      if( btnval == "Clicked"){
        createCookie("PriceSwatch", "SHOW");
        createCookie("PriceBtnLabel", "Hide Prices");
        jQuery("#PriceSwatch").html('Hide Prices');
        jQuery("body").addClass('product-price-show');
      }
    } else if(priceVal != "" && priceVal == "SHOW"){
      jQuery("#PriceSwatch").html(buttonVal);
      jQuery("body").addClass('product-price-show');
      if( btnval == "Clicked"){
        createCookie("PriceSwatch", "HIDE");
        createCookie("PriceBtnLabel", "Show Prices");
        jQuery("#PriceSwatch").html('Show Prices');
        jQuery("body").removeClass('product-price-show');
      }
    } else {
      createCookie("PriceSwatch", "SHOW");
      createCookie("PriceBtnLabel", "Hide Prices");
      jQuery("body").addClass('product-price-show');
    }
}

function createCookie(name, value) {
    var expires;
    var date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
    
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}